import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { URL_IMAGES_FLAG } from 'apps/auth/constants/UrlConstants';
import media from 'apps/auth/theme/media';

export type FlagIconSize = '16px' | '20px' | '24px' | '28px' | '40px' | 'x-small' | 'small' | 'large';

interface PngIconProps {
    $size?: FlagIconSize;
    $isDisabled?: boolean;
}

const getSize = (props: PngIconProps) => {
    switch (props.$size) {
        case '16px':
            return '16px';
        case '20px':
            return '20px';
        case '24px':
            return '24px';
        case '28px':
            return '28px';
        case '40px':
            return '40px';
        case 'x-small':
            return '24px';
        case 'small':
            return '40px';
        case 'large':
            return '80px';
        default:
            return '24px';
    }
};

const getDesktopSize = (props: PngIconProps) => {
    switch (props.$size) {
        case '16px':
            return '16px';
        case '20px':
            return '20px';
        case '24px':
            return '24px';
        case '28px':
            return '28px';
        case '40px':
            return '40px';
        case 'x-small':
            return '28px';
        case 'small':
            return '56px';
        case 'large':
            return '112px';
        default:
            return '24px';
    }
};

const PngIcon = styled.span<PngIconProps>`
    display: inline-block;
    position: relative;
    width: ${(props) => getSize(props)};
    height: ${(props) => getSize(props)};
    overflow: hidden;
    border-radius: 50%;
    vertical-align: top;
    opacity: ${(props) => (props.$isDisabled ? '0.32' : null)};
    flex-shrink: 0;

    &:before {
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 50%;
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }

    img {
        max-width: 100%;
    }

    ${media.desktop1920} {
        width: ${(props) => getDesktopSize(props)};
        height: ${(props) => getDesktopSize(props)};
    }
`;

export interface FlagIconProps {
    name?: string;
    size?: FlagIconSize;
    isDisabled?: boolean;
}

export const FlagIcon = ({ name, size, isDisabled }: FlagIconProps) => {
    if (!name) {
        return null;
    }

    return (
        <PngIcon $size={size} $isDisabled={isDisabled}>
            <img src={`${URL_IMAGES_FLAG}/${name}.png`} alt={name} loading="lazy" decoding="async" />
        </PngIcon>
    );
};

FlagIcon.propTypes = {
    name: PropTypes.string,
    size: PropTypes.oneOf(['16px', '20px', '24px', '28px', '40px', 'x-small', 'small', 'large']),
    isDisabled: PropTypes.bool,
};
